// extracted by mini-css-extract-plugin
export var wordContainer = "_sf-0";